"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/**
 * Update order wide notes
 * Can only be done in any order status
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    order.orderItems = order.orderItems || [];
    const orderItem = order.orderItems.find(x => x.id === event.orderItemId);
    if (orderItem === undefined || event.note === undefined) {
        return order;
    }
    orderItem.notes = event.note;
    return order;
}
exports.default = default_1;
//# sourceMappingURL=addOrderItemNotes.js.map